import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ViewChildren,
  QueryList,
  AfterViewInit,
  ViewChild,
  Output, EventEmitter, afterNextRender
} from '@angular/core';
import {
  AbstractControl,
  FormControl, UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import {ModalInterface} from '../../modal.interface';
import {Subscription, Observable, Subject, mergeMap, of, forkJoin} from 'rxjs';
import {ModalStateEvent} from '../../modal-state-event';
import {ResultsListTabInterface} from '../../../../core/components/search-results-list/results-list-tab.interface';
import {RxFormArray, RxFormBuilder, RxwebValidators} from '@rxweb/reactive-form-validators';
import {ModalState} from '../../modal-state.enum';
import {SearchTabsEnum} from "../../../../core/components/search-results-list/search-tabs.enum";
import {VehicleTypeViewModel} from "../../../../core/models/vehicle-type.view-model";
import {MakeViewModel} from "../../../../core/models/make.view-model";
import {BodyTypeViewModel} from "../../../../core/models/body-type.view-model";
import {ModelViewModel} from "../../../../core/models/model.view-model";
import {BodyGenViewModel} from "../../../../core/models/body-gen.view-model";
import {VehicleViewModel} from "../../../../features/user/garage/vehicle.view-model";
import {FiltersDataProviderService} from "../../../services/filters.data-provider.service";
import {MultiSelect} from "primeng/multiselect";
import {AutoComplete, AutoCompleteSelectEvent} from "primeng/autocomplete";
import {SelectItem} from "primeng/api";
import {MapComponent} from "../../../map/map.component";
import {MapService} from "../../../map/map.service";
import {debounceTime, delay, distinctUntilChanged, map, startWith, take, tap} from "rxjs/operators";
import {Params} from "@angular/router";
import {AbstractDictionaryApiModel} from "../../../../api/models/abstract-dictionary.api-model";
import {AbstractDictionaryViewModel} from "../../../../core/models/abstract-dictionary.view-model";
import {OffersDataProviderService} from "../../../marketplace/offers.data-provider.service";
import {ModalComponent} from "../../modal.component";
import {TranslateService} from "@ngx-translate/core";
import {ModalService} from "../../modal.service";
import {AbstractComponent} from "../../../../core/components/abstract-component";
import {AddEventProviderService} from "../add-event/add-event.provider.service";
import {QueryParamsApiModel} from "../../../../api/models/query-params-api.model";
import {FilterParameterApiModel} from "../../../../api/models/filter-parameter.api.model";
import {UserViewModel} from "../../../../features/user/settings/user.view-model";
import {AppBreadcrumbService} from "../../../navbar/app.breadcrumb.service";
import {Router} from "@angular/router";
import {setSessionStorageItem} from "../../../../core/helpers/browser-storage.helper";
import {UserLocationService} from "../../../../core/services/user-location.service";
import {TokenDataProviderService} from "../../../../core/services/token-data-provider.service";


@Component({
  selector: 'app-search-filters',
  templateUrl: './search-filters.component.html',
  styleUrls: ['./search-filters.component.scss'],
})
export class SearchFiltersComponent extends AbstractComponent implements OnInit, AfterViewInit, ModalInterface, OnDestroy {
  get form(): UntypedFormGroup {
    return this.filtersDPS.form;
  }

  set form(value: UntypedFormGroup) {
    this.filtersDPS.form = value;
  }

  constructor(
    private readonly fb: RxFormBuilder,
    private readonly mapService: MapService,
    public readonly filtersDPS: FiltersDataProviderService,
    public readonly offerDPS: OffersDataProviderService,
    public readonly eventPS: AddEventProviderService,
    public readonly translate: TranslateService,
    public readonly ms: ModalService,
    private readonly breadcrumb: AppBreadcrumbService,
    private readonly router: Router,
    private readonly userLocationService: UserLocationService,
    private readonly tokenDPS: TokenDataProviderService
  ) {
    super();
  }

  @Input()
  public data: { selectedTab: ResultsListTabInterface; searchQuery?: string; mobileFocusTopOffset?: number };
  @Input() public mobileFocusTopOffset: number | null = null;
  @Output() onReset: EventEmitter<void> = new EventEmitter<void>();
  public currentDate: Date = new Date();
  public state: Observable<ModalStateEvent>;
  public models: ModelViewModel[];
  public bodyGens: BodyGenViewModel[];
  public vehicle: VehicleViewModel;
  public searchResults: SelectItem[] = [];
  public subject: Subject<ModalStateEvent>;
  public readonly SearchTabsEnum = SearchTabsEnum;
  public parent: ModalComponent;
  public organizers: any[] = [];
  public distanceValue$: Observable<number>;
  public initialMapCenter = {lat: 0, lon: 0};
  public initialMapMarker?: {lat: number; lon: number};
  public searchMapContentReady = false;
  public mapActive = false;

  @ViewChild(MapComponent)
  public mapComponent: MapComponent;
  @ViewChild('marketplaceAddress')
  public marketplaceAddress: AutoComplete;
  @ViewChildren(MultiSelect)
  private queryList: QueryList<MultiSelect>;
  public subscription: Subscription;

  public ngOnInit(): void {
    this.createForm();
    this.initDistanceValue();
    this.parent = this.ms.modalInstance;
    this.parent.hasResetButton = true;
    this.filtersDPS.subject = this.subject = this.ms.modalInstance.modalSubject
    this.state = this.subject.asObservable();
    if (this.data.selectedTab.type === SearchTabsEnum.EVENTS) {
      this.subscriptions.push(this.eventPS.fetchResourcesFromQuerySubject().subscribe());
    }
  }

  ngAfterViewInit(): void {
    this.queryList.forEach((e: MultiSelect) => {
      e.el.nativeElement.removeAttribute('pautofocus');
      e.el.nativeElement.setAttribute('inputmode', 'none');
      e.focusInputViewChild?.nativeElement.removeAttribute('pautofocus');
      e.focusInputViewChild?.nativeElement.setAttribute('inputmode', 'none');
    });
    this.subscribeToModalStates();
    this.setInitialMapLocation();
    if (this.data.selectedTab.type === SearchTabsEnum.MARKETPLACE) {
      this.filtersDPS.subscriptions.push(this.filtersDPS.updateMarketplaceFilters().subscribe(() => {
        this.ms.emitState(ModalState.VALID, null);
        this.subscribeToFormValueChanges();
        this.filtersDPS.fetchAdvertisementsResultCount();
      }));
    } else if (this.data.selectedTab.type === SearchTabsEnum.USERS) {
      this.filtersDPS.subscriptions.push(this.filtersDPS.updateUserFilters().subscribe(() => {
        this.ms.emitState(ModalState.VALID, null);
      }));
    } else if (this.data.selectedTab.type === SearchTabsEnum.PROJECTS) {
      this.filtersDPS.subscriptions.push(this.filtersDPS.updateProjectFilters().subscribe(() => {
        this.ms.emitState(ModalState.VALID, null);
      }));
    } else {
      setTimeout(() => {
        this.filtersDPS.subscriptions.push(this.filtersDPS.updateEventFilters().subscribe(() => {
          this.syncSearchQueryToEventName();
          this.ms.emitState(ModalState.VALID, null);
          this.syncOrganizersFromForm();
          this.subscribeToEventFormValueChanges();
          this.filtersDPS.fetchEventsResultCount();
        }));
      });
    }
  }


  subscribeToFormValueChanges() {
    if (this.data.selectedTab.type !== SearchTabsEnum.MARKETPLACE) {
      return;
    }

    this.filtersDPS.subscriptions.push(this.form.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(),
    ).subscribe(() => {
      this.filtersDPS.fetchAdvertisementsResultCount();
    }));
  }

  subscribeToEventFormValueChanges() {
    if (this.data.selectedTab.type !== SearchTabsEnum.EVENTS) {
      return;
    }

    this.filtersDPS.subscriptions.push(this.form.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(),
    ).subscribe(() => {
      this.filtersDPS.fetchEventsResultCount();
    }));
  }

  private subscribeToModalStates() {
    this.filtersDPS.subscriptions.push(this.state.subscribe((mse: ModalStateEvent) => {
      switch (mse.status) {
        case ModalState.RESET:
          this.resetFilters();
          this.resetSearchQueryIfNeeded();
          break;
        case ModalState.VALID:
          const addr = this.form.get('address').value;
          if (this.mapComponent && addr && addr.length) {
            if (this.mapComponent.isRendered) {
              this.updateMap(addr[0].value);
            } else {
              this.mapComponent.isRenderedEmitter.pipe(take(1)).subscribe(() => this.updateMap(addr[0].value));
            }
          }
          break;
        case ModalState.PENDING:
          if (this.data.selectedTab.type === SearchTabsEnum.EVENTS) {
            this.syncSearchQueryFromEventName();
          }
          this.filtersDPS.subject.next(new ModalStateEvent(ModalState.SUCCESS, this.getFilters()));
          break;
        case ModalState.HIDE:
          if (this.data.selectedTab.type === SearchTabsEnum.MARKETPLACE) {
            this.filtersDPS.updateMarketplaceFiltersForm();
          } else if (this.data.selectedTab.type === SearchTabsEnum.USERS) {
            this.filtersDPS.updateUserFiltersForm();
          } else if (this.data.selectedTab.type === SearchTabsEnum.PROJECTS) {
            this.filtersDPS.updateProjectFiltersForm();
          } else {
            this.filtersDPS.updateEventFiltersForm();
            this.syncOrganizersFromForm();
          }
          break;
      }
    }));
  }

  private syncSearchQueryToEventName(): void {
    if (this.data?.selectedTab?.type !== SearchTabsEnum.EVENTS) {
      return;
    }
    if (!this.form?.controls?.name) {
      return;
    }
    if (typeof this.data.searchQuery === 'string') {
      const name = this.data.searchQuery.trim();
      this.form.patchValue({ name: name.length ? name : null }, { emitEvent: false });
    }
  }

  private syncSearchQueryFromEventName(): void {
    if (this.data?.selectedTab?.type !== SearchTabsEnum.EVENTS) {
      return;
    }
    if (!this.router.url.includes('/search-results')) {
      return;
    }
    const name = String(this.form.get('name')?.value || '').trim();
    if (this.breadcrumb.query !== name) {
      this.breadcrumb.query = name;
      this.router.navigate([], { queryParams: name ? { q: name } : {}, replaceUrl: true });
    }
  }

  private resetSearchQueryIfNeeded(): void {
    if (!this.router.url.includes('/search-results')) {
      return;
    }
    this.breadcrumb.query = '';
    this.router.navigate([], { queryParams: {}, replaceUrl: true });
  }

  private createForm() {
    switch (this.data.selectedTab.type) {
      case SearchTabsEnum.MARKETPLACE:
        this.createMarketplaceFiltersForm();
        break;
      case SearchTabsEnum.USERS:
        this.createUserFiltersForm();
        break;
      case SearchTabsEnum.PROJECTS:
        this.createProjectFiltersForm();
        break;
      case SearchTabsEnum.EVENTS:
        this.createEventFiltersForm();
        break;
      default:
        this.createEventFiltersForm();
        break;
    }
  }

  private createMarketplaceFiltersForm() {
    this.form = this.filtersDPS.createMarketplaceFiltersForm();
  }

  private createEventFiltersForm() {
    this.form = this.filtersDPS.createEventFiltersForm();
  }

  private createUserFiltersForm() {
    this.form = this.filtersDPS.createUserFiltersForm();
  }

  private createProjectFiltersForm() {
    this.form = this.filtersDPS.createProjectFiltersForm();
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.parent) {
      this.parent.hasResetButton = false;
    }

    this.filtersDPS.unsubscribeAll();
  }

  public seekMakes(vehicleTypeVMs: AbstractDictionaryViewModel<AbstractDictionaryApiModel>[]): void {
    this.subscription = this.filtersDPS.seekMakes(vehicleTypeVMs).subscribe();
    this.subscriptions.push(this.subscription);
  }

  public seekModels(vehicleTypeVM: VehicleTypeViewModel[], makeVM: MakeViewModel[]): void {
    this.subscription = this.filtersDPS.seekModels(vehicleTypeVM, makeVM).subscribe();
    this.subscriptions.push(this.subscription);
  }

  // public seekBodyGens(
  //   vehicleTypeVM: VehicleTypeViewModel,
  //   makeVM: MakeViewModel,
  //   bodyTypeVM: BodyTypeViewModel,
  //   modelVM: ModelViewModel
  // ): void {
  //   this.subject.next(new ModalStateEvent(ModalState.PROCESS));
  //   this.filtersDPS.disableRelatedChoices('bodyGen');
  //   this.filtersDPS.unsubscribePending();
  //   this.subscription = this.filtersDPS.getBodyGenCollection(vehicleTypeVM, makeVM, bodyTypeVM, modelVM).subscribe(
  //     (bodyGenVMs: BodyGenViewModel[]) => {
  //       this.bodyGens = bodyGenVMs;
  //       this.form.get('bodyGen').enable();
  //       this.subject.next(new ModalStateEvent(ModalState.PROCESS_END));
  //     },
  //     error => {
  //
  //     }
  //   );
  // }

  public getFilters(): Params {
    return this.filtersDPS.getFilters()
  }

  searchPlaces(event: any) {
    const sub = this.mapService.subscribeToQuerySubject().subscribe((results: any[]) => {
      this.searchResults = results.map(result => ({label: result.display_name, value: result}));
      if (!this.searchResults.length) {
        this.form.get('address').setErrors({incorrect: true, message: 'This is not valid place'});
      }
      sub.unsubscribe();
    });
    this.mapService.searchPlaces(event.query);
  }

  selectPlace(event: AutoCompleteSelectEvent) {
    setSessionStorageItem(this.getAddressStorageKey(), JSON.stringify(event.value));
    const addrInput = this.form.get('address')
    addrInput.setValue([event.value]);
    addrInput.setErrors(null);
    const item: any = event.value.value;
    if (this.data.selectedTab.type === SearchTabsEnum.USERS) {
      this.updateMap(item);
      return;
    }
    this.updateMap(item);
  }

  updateMap(item: any): void {
    if (!this.mapComponent) {
      return;
    }
    const iMarker = {lat: item.lat as number, lon: item.lon as number};

    this.mapComponent.layerMarkers.forEach((marker) => {
      this.mapComponent.removeMarker(marker);
    });

    this.mapComponent.layerCircles.forEach((circle) => {
      this.mapComponent.removeCircle(circle);
    });

    this.mapComponent.addMarker(iMarker);
    this.mapComponent.updateMapCenter(iMarker);
    this.mapComponent.addCircleRadius(iMarker, this.form.get('distance').value);
    this.mapComponent.waitUntilReady();
  }

  private setInitialMapLocation(): void {
    this.tokenDPS.currentUser.pipe(take(1)).subscribe((user) => {
      const fallbackCity = this.getProfileCity(user?.info);
      this.subscriptions.push(this.userLocationService.resolveMapLocation(fallbackCity).pipe(take(1)).subscribe((location) => {
        if (!location.coordinates) {
          this.searchMapContentReady = true;
          return;
        }
        const marker = {lat: location.coordinates.lat, lon: location.coordinates.lng};
        this.initialMapCenter = marker;
        this.initialMapMarker = marker;
        this.searchMapContentReady = true;
        if (this.mapComponent?.isRendered) {
          this.updateMap(marker);
          return;
        }
        this.mapComponent?.isRenderedEmitter.pipe(take(1)).subscribe(() => {
          this.mapComponent.addCircleRadius(marker, this.form.get('distance').value);
          this.mapComponent.waitUntilReady();
        });
      }, () => {
        this.searchMapContentReady = true;
      }));
    });
  }

  public onModalShown(): void {
    this.mapActive = true;
  }

  private getProfileCity(info: unknown): string | undefined {
    if (typeof info === 'string') {
      try {
        info = JSON.parse(info);
      } catch {
        return undefined;
      }
    }
    return (info as {city?: {name?: string}} | null)?.city?.name;
  }

  updateRadius(): void {
    if (!this.mapComponent) {
      return;
    }
    this.mapComponent.updateCircleRadius(this.form.get('distance').value);
  }

  getAddrOptionValue(item: SelectItem): any {
    return item.value;
  }

  getAddrOptionLabel(item: any): any {
    return item.label;
  }

  public resetFilters(): void {
    this.filtersDPS.resetFilters();
    if (this.data.selectedTab.type === SearchTabsEnum.EVENTS) {
      this.organizers = [];
      this.form.get('organizerQuery').setValue(null, {emitEvent: false});
    }
    this.onReset.emit();
  }

  public enabledFilters(): number {
    return this.filtersDPS.enabledFilters(this.data?.selectedTab?.type === SearchTabsEnum.EVENTS);
  }

  public getNumOfSeaterControl(): FormControl | (FormControl & AbstractControl) | (undefined & FormControl) | (undefined & FormControl & AbstractControl) {
    return this.form.controls['project.vehicle.bodyWork.numOfSeater'] as FormControl;
  }

  public getNumOfDoorsControl(): FormControl | (FormControl & AbstractControl) | (undefined & FormControl) | (undefined & FormControl & AbstractControl) {
    return this.form.controls['project.vehicle.bodyWork.numOfDoors'] as FormControl;
  }


  public getEquipmentControl(): FormControl | (FormControl & AbstractControl) | (undefined & FormControl) | (undefined & FormControl & AbstractControl) {
    return this.form.controls['project.equipment'] as FormControl;
  }

  emitOrganizerQuery(queryEvt) {
    this.eventPS.resultSubject$.next(queryEvt.query);
  }

  addOrganizer(item: any, autocomplete: AutoComplete) {
    if (this.organizers.find(e => e.alias === item.alias)) {
      return;
    }

    this.organizers = [...this.organizers, item];
    this.form.get('organizers').setValue(this.organizers);
    this.form.get('organizerQuery').setValue(null);
    autocomplete.writeValue(null);
  }

  private initDistanceValue(): void {
    const distanceControl = this.form?.get('distance');
    if (distanceControl) {
      this.distanceValue$ = distanceControl.valueChanges.pipe(
        startWith(distanceControl.value),
        delay(0)
      );
      this.subscriptions.push(distanceControl.valueChanges.pipe(
        debounceTime(250),
        distinctUntilChanged()
      ).subscribe(() => {
        this.updateRadius();
      }));
    }
  }

  public onDateRangeClear(event?: Event): void {
    if (event) {
      // Stop calendar from opening when clear icon is clicked.
      (event as any).stopImmediatePropagation?.();
      event.preventDefault();
      event.stopPropagation();
    }
    const control = this.form.get('dateRange');
    control.reset(null);
    control.markAsDirty();
    control.updateValueAndValidity();
  }

  removeOrganizer(item: any) {
    this.organizers = this.organizers.filter(e => e.alias !== item.alias);
    this.form.get('organizers').setValue(this.organizers);
  }

  private syncOrganizersFromForm(): void {
    const organizers = this.form.get('organizers')?.value;
    if (!organizers || !organizers.length) {
      this.organizers = [];
      this.form.get('organizerQuery').setValue(null, {emitEvent: false});
      return;
    }

    const hasObjects = organizers.some((item: any) => item && typeof item === 'object' && item.alias);
    if (hasObjects) {
      this.organizers = organizers;
      this.form.get('organizerQuery').setValue(null, {emitEvent: false});
      return;
    }

    const values = organizers
      .map((item: any) => String(item))
      .map((value: string) => value.split('/').pop())
      .filter((value: string) => value);

    if (!values.length) {
      this.organizers = [];
      this.form.get('organizerQuery').setValue(null, {emitEvent: false});
      return;
    }

    const queryParams = new QueryParamsApiModel();
    values.forEach((value: string) => {
      const isNumeric = /^\d+$/.test(value);
      queryParams.filters.push(new FilterParameterApiModel(isNumeric ? 'id' : 'slug', value, 'array'));
    });

    this.filtersDPS.subscriptions.push(this.eventPS.fetchUsers(queryParams).subscribe(([users]: UserViewModel[][]) => {
      this.organizers = users.map((user: UserViewModel) => this.eventPS.createUserInterface(user));
      this.form.get('organizers').setValue(this.organizers);
      this.form.get('organizerQuery').setValue(null, {emitEvent: false});
    }));
  }

  private getAddressStorageKey(): string {
    return this.data.selectedTab.type === SearchTabsEnum.EVENTS
      ? 'event.search.address'
      : this.data.selectedTab.type === SearchTabsEnum.USERS
        ? 'user.search.address'
        : this.data.selectedTab.type === SearchTabsEnum.PROJECTS
          ? 'project.search.address'
          : 'marketplace.search.address';
  }
}
